import SkeletonBlock from './SkeletonBlock';

interface SkeletonHabitPackCardProps {
  className?: string;
}

const SkeletonHabitPackCard = ({ className = '' }: SkeletonHabitPackCardProps) => (
  <div
    className={`w-full shrink-0 rounded-lg border border-secondary-400/60 bg-white dark:bg-secondary-dark-100 shadow-sm sm:shadow-md ~p-3/4 animate-pulse ${className}`}
    data-testid='skeleton-habit-pack-card'>
    <div className='w-full flex items-center justify-between ~gap-2/3'>
      <div className='flex-1 min-w-0 flex flex-col ~gap-1.5/2'>
        <SkeletonBlock className='~h-4/5 ~w-40/56 border-0' />
        <div className='flex items-center ~gap-1.5/2'>
          <SkeletonBlock className='~h-3/4 ~w-14/16 border-0' />
          <SkeletonBlock className='~h-3/4 ~w-24/32 border-0' />
        </div>
      </div>
      <SkeletonBlock className='~w-4/5 ~h-4/5 flex-shrink-0 border-0' />
    </div>
  </div>
);

export default SkeletonHabitPackCard;
